import { useState } from 'react'

import { BackgroundSection } from '@/layouts/DefaultLayout/components/BackgroundSection/BackgroundSection'
import { Content } from '@/layouts/DefaultLayout/components/Content/Content'

import { PasswordResetForm } from '@/modules/passwordReset/components/PasswordResetForm/PasswordResetForm'

import { Text } from '@/components/Text/Text'
import { Title } from '@/components/Title/Title'

export function Component() {
  const [successMessage, setSuccessMessage] = useState('')

  return (
    <>
      <BackgroundSection image="welcome_image_step_1.png" />
      <Content>
        {!successMessage && (
          <>
            <Title variant="h1">Reset Your Password</Title>
            <Text>We will send you an email to reset your password.</Text>

            <PasswordResetForm setSuccessMessage={setSuccessMessage} />
          </>
        )}

        {successMessage && <Text>{successMessage}</Text>}
      </Content>
    </>
  )
}

Component.displayName = 'PasswordReset'
